export default {
  licenseKey: "3AAF9650-2EB641C5-91E1ED66-B5D30F2B",
  scrollBar: true,
  verticalCentered: false,
  menu: ".page-navbar ul",
  responsiveWidth: 767,
  responsiveHeight: 650,
  scrollingSpeed: 0,
  loopTop: true,
  loopBottom: true,
  paddingTop: 0,
  paddingBottom: 0
};
